// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"199c4c30","455":"8d777f3d","977":"a440bfa9"}[chunkId] + ".chunk.js";
};